import { useQuery } from '@tanstack/react-query';

import { format, parseISO } from 'date-fns';

import {
  IndividualDeductionsReport,
  individualDeductionsReportsService,
  individualsService,
  payCalendarsService,
} from '@aslanpay/portal-common-lib';

export const fetchIndividualDeductionsReportQuery = (id?: string, enabled = true) => ({
  queryKey: ['fetchIndividualDeductionsReport', id],
  queryFn: async () => {
    const reports = await individualDeductionsReportsService.fetchIndividualDeductionsReports({
      ids: [id || ''],
      page: 0,
      size: 1,
    });

    const payCalendar = await payCalendarsService.fetchPayCalendar(reports.list[0].payCalendarId);

    let employeeName = 'Deleted User';
    try {
      const employee = await individualsService.fetchIndividual(reports.list[0].individualId);
      employeeName = employee.firstName
        ? `${employee.firstName} ${employee.lastName}`
        : employee.email;
    } catch {
      // employee has been deleted
    }

    const payCycle = payCalendar.payCycles.find((cycle) => cycle.id === reports.list[0].payCycleId);

    const payCycleName = payCycle
      ? format(parseISO(payCycle.startDate as string), 'MMMM yyyy')
      : '';

    return { ...reports?.list[0], payCycleName, employeeName };
  },
  enabled: !!id && enabled,
});

const useFetchIndividualDeductionsReport = (id?: string, enabled = true) => {
  return useQuery<
    IndividualDeductionsReport & { payCycleName: string; employeeName: string },
    Error
  >(fetchIndividualDeductionsReportQuery(id, enabled));
};

export default useFetchIndividualDeductionsReport;
